import {
	Card,
	CardBody,
	Input,
	TableRow,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import AirportPickupPeriodicHikeTimeTable from 'components/airportPickupPeriodicHikeTime/AirportPickupPeriodicHikeTimeTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import { SidebarContext } from 'context/SidebarContext';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import AirportPickupPeriodicHikeTimeServices from 'services/AirportPickupPeriodicHikeTimeServices';
import { FiPlus } from 'react-icons/fi';
import AirportPickupPeriodicHikeTimeDrawer from 'components/drawer/AirportPickupPeriodicHikeTimeDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import sidebar from 'routes/sidebar';

const AirportPickupPeriodicHikeTime = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { toggleDrawer } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [status, setStatus] = useState('');
	const { data, loading, error } = useAsync(
		AirportPickupPeriodicHikeTimeServices.getAllAirportPickupPeriodicHikeTime
	);

	const isDataArray = Array.isArray(data?.data); // Check if data is an array
	const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

	const isAdmin = adminInfo?.id === 1;

	const hideView = adminInfo?.permission?.some(
				(perm) =>
					perm.id_tab === 'airport periodic hike time' && perm.view === 1
		  );

	const hideDelete = adminInfo?.permission?.some(
				(perm) =>
					perm.id_tab === 'airport periodic hike time' && perm.delete === 1
		  );

	const hideEdit = adminInfo?.permission?.some(
				(perm) =>
					perm.id_tab === 'airport periodic hike time' && perm.edit === 1
		  );

	const hideAdd = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'airport periodic hike time' && perm.add === 1
		  );

	const hideExport = adminInfo?.permission?.some(
				(perm) =>
					perm.id_tab === 'airport periodic hike time' && perm.export === 1
		  );
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const {
		airportPickupPeriodicHikeTimeRef,
		dataTable,
		serviceData,
		handleSubmitAirportPickupPeriodicHikeTime,
		currentPage,
	} = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);
	const updatedData = safeData.map(({ id, ...rest }) => rest);
	// console.log("airport pickup hicktime", updatedData);
	
	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	  const finalData = data?.data?.map((item, index) => {
    return {
      "SI.No": index + 1,
      "Airport": item.city_names, 
	  "Start Time": item.start_time,
	  "End Time": item.end_time, 
	  "Vehicle Type": item.vehicle_type_names, 
	  "Hike": item.hike ? `${item.hike}%` : "", 
    };
  });
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />

					<MainDrawer>
						<AirportPickupPeriodicHikeTimeDrawer id={serviceId} />
					</MainDrawer>

					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={airportPickupPeriodicHikeTimeRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitAirportPickupPeriodicHikeTime}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Periodic Time Rate
									</Button>
								)}

								{hideExport && (
									<ExportDataXlsx
										exportDataXlsx={finalData}
										fileNames="Airport Pickup Periodic Hike Time"
									/>
								)}
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData.length ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
											<TableRow>
												<TableCell>Sl.No.</TableCell>
												<TableCell>Airport</TableCell>
												<TableCell>Start Time</TableCell>
												<TableCell>End Time</TableCell>
												<TableCell>Vehicle Type</TableCell>
												<TableCell>Hike (%)</TableCell>
												<TableCell>Actions</TableCell>
											</TableRow>
										</TableHeader>
										<AirportPickupPeriodicHikeTimeTable
											airportPickupPeriodicHikeTime={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											hideDelete={hideDelete}
											hideEdit={hideEdit}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{data.status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Day Rental Periodic Hikes." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default AirportPickupPeriodicHikeTime;
